import React, { useState, useContext } from 'react';
import { Box } from 'grommet';
import { TEAM_SETTINGS, TEAM_SETTINGS__STREAM_MENU } from '@constants/routes';
import { TeamContext } from '@services/Session';
import SHDButton from '@ui/Button/SHDButton';
import Toast from '@components/Toast';
import { UI } from '@constants/baseUrls';
import { useHistory } from 'react-router-dom';

interface TeamActionButtonsProps {
  setShowQrModal: (show: boolean) => void;
  screenSize?: string;
  isScoringLink: boolean;
}

const TeamActionButtons: React.FC<TeamActionButtonsProps> = ({
  setShowQrModal,
  screenSize = 'medium',
  isScoringLink,
}) => {
  const teamStore = useContext(TeamContext);
  const isAdmin = teamStore.isTeamManager;
  const teamId = teamStore.id;
  const history = useHistory();
  const [copied, setCopied] = useState(false);

  const handleShare = () => {
    const scoreDelegationKey = localStorage.getItem('scoreDelegationKey');
    const url = `${UI}/${teamId}?tab=scoring&key${scoreDelegationKey}`;
    if (navigator.share) {
      navigator.share({
        title: `${teamStore.nameLong} on sidelineHD`,
        text: `View ${teamStore.nameLong} on sidelineHD`,
        url: url,
      });
    } else {
      navigator.clipboard.writeText(url);
      setCopied(true);
    }
  };

  return (
    <Box key="team-action-buttons" justify="start">
      <Box>
        {isScoringLink ? (
          <SHDButton
            pill
            onClick={handleShare}
            label="Share scoring link"
            border={true}
          />
        ) : (
          <Box gap="xsmall" direction="row" justify="end" fill="horizontal">
            <SHDButton
              pill
              border
              label="Share"
              onClick={() => {
                setShowQrModal(true);
              }}
            />
            {isAdmin && (
              <SHDButton
                pill
                border
                label="Settings"
                onClick={() =>
                  history.push(
                    screenSize === 'small'
                      ? TEAM_SETTINGS
                      : TEAM_SETTINGS__STREAM_MENU
                  )
                }
              />
            )}
          </Box>
        )}
      </Box>
      {copied && (
        <Toast
          label="Copied to clipboard!"
          background="status-ok"
          duration={3000}
          onClose={() => setCopied(false)}
        />
      )}
    </Box>
  );
};

export default TeamActionButtons;
